module.exports = __webpack_public_path__ + "netlink-dash.fe266fca976b73735ab2.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/netlink-dash.svg
// module id = ../../../../../src/img/netlink-dash.svg
// module chunks = styles